import { createApi } from "@reduxjs/toolkit/query/react";

import { IWareHouseDetailItem } from "@/interfaces/ware-house.interface";
import { BaseWithAuth } from "@/utils/helpers";

export const C_WareHouseAPI = createApi({
  reducerPath: "C_WareHouseAPI",
  baseQuery: BaseWithAuth(),
  tagTypes: [
    "warehouseItems",
    "warehouseActiveProjects",
    "warehouseAssignHistory",
  ],
  endpoints: (builder) => ({
    // get all the items in the warehouse
    getCustomersWareHouseItems: builder.query<
      GeneralResponse<IWareHouseDetailItem[] | IWareHouseDetailItem>,
      { customerId: string; filters?: string }
    >({
      query: ({ customerId, filters }) =>
        `customer/${customerId}/warehouse/items${filters ? `?${filters}` : ""}`,
      providesTags: ["warehouseItems"],
    }),

    //Get WareHouse Detail Assign History
    getCustomerWareHouseAssignHistory: builder.query<
      GeneralResponse<IWareHouseDetailItem[]>,
      {
        customerId: string;
        filters: string;
      }
    >({
      query: ({ customerId, filters }) =>
        `customer/${customerId}/warehouse/history${filters ? `?${filters}` : ""}`,
      providesTags: ["warehouseAssignHistory"],
    }),

    //Get WareHouse Detail Projects
    getCustomerWareHouseProjects: builder.query<
      GeneralResponse<IWareHouseDetailItem[]>,
      {
        customerId: string;
        filters: string;
      }
    >({
      query: ({ customerId, filters }) =>
        `customer/${customerId}/warehouse/projects${filters ? `?${filters}` : ""}`,
      providesTags: ["warehouseActiveProjects"],
    }),
  }),
});

export const {
  useGetCustomersWareHouseItemsQuery,
  useGetCustomerWareHouseAssignHistoryQuery,
  useGetCustomerWareHouseProjectsQuery,
} = C_WareHouseAPI;
